import { ApiRequestError } from '@/lib/api';
import { fromLocalInput, todayInTz } from '@/lib/format';

export interface UndoForm {
  refundedAt: string;
  /** Motivo de caída de la devolución (catálogo, no técnico). */
  dropReason: string;
  reason: string;
  notes: string;
  /**
   * Motivo técnico de la anulación (ERROR DATA…). Va aparte del de la devolución (P26, ux-comercial-28): antes los
   * dos modos compartían el campo y un «Precio» elegido en Devolución viajaba escondido en la anulación.
   */
  techReason: string;
}

/** Formulario vacío con «hoy» en la zona de la empresa (de noche, UTC ya iría en mañana; ux-comercial-14). */
export function emptyUndoForm(tz?: string): UndoForm {
  return {
    refundedAt: todayInTz(tz),
    dropReason: '',
    reason: '',
    notes: '',
    techReason: '',
  };
}

/**
 * Instante de un hecho a partir de la fecha elegida: hoy = ahora (nunca futuro ni anterior a lo registrado el
 * mismo día); otro día = mediodía de la zona de la empresa. Lo usan la devolución y las correcciones de fechas.
 */
export function dayInstant(dateStr: string, tz?: string): Date {
  return dateStr === todayInTz(tz) ? new Date() : new Date(fromLocalInput(`${dateStr}T12:00`, tz));
}

/** Instante de devolución a partir de la fecha elegida (ver `dayInstant`). */
export const refundInstant = dayInstant;

/** Aviso cuando el lead tiene más de un proceso vivo: «Devolver y desistir» en un paso no cabe (Lote 5 · H1). */
export function multipleLiveDealsNotice(count: number): string {
  return `Este lead tiene ${count} procesos vivos: devuélvelos uno por uno y desiste en el último.`;
}

/**
 * Mensaje del error de una devolución / anulación. `DESIST_WITH_ACTIVE_DEAL` llega cuando se pidió «Desistir» como
 * siguiente paso y al lead le quedaba otro proceso vivo: la API revirtió todo (tampoco quedó la devolución).
 */
export function undoErrorMessage(err: unknown, fallback: string): string {
  if (!(err instanceof ApiRequestError)) return fallback;
  const code = (err.body.details as { code?: unknown } | undefined)?.code;
  if (code === 'DESIST_WITH_ACTIVE_DEAL')
    return 'No se registró nada: al lead le queda otro proceso vivo (separación o venta). Devuélvelos uno por uno y desiste en el último.';
  return err.message;
}
